import React, { useEffect } from "react";
import SideBar from "../components/organisms/SideBar";
import { Outlet } from "react-router-dom";
import { getAuthToken } from "../utils/token";
import { useAuthContext } from "../context/AuthContext";
import Header from "../components/atoms/Header";
import { useQuery } from "@tanstack/react-query";
import { getApi } from "../utils/api/api_instance";

const Root = () => {
  const { setAuthUser } = useAuthContext();
  const { data } = useQuery({
    queryKey: ["verify-token"],
    queryFn: async () => {
      try {
        const token = getAuthToken();
        if (!token) {
          return { hasAuthData: false };
        } else {
          const { data } = await getApi({
            apiUrl: "/admin/api/user/auth",
            sendToken: true,
            logout: setAuthUser,
          });
          return { hasAuthData: true, userData: data };
        }
      } catch (error) {
        throw error;
      }
    },
  });

  useEffect(() => {
    if (data.hasAuthData) {
      setAuthUser(data.userData);
    }
  }, [data, setAuthUser]);

  return (
    <div className="flex w-full">
      <SideBar />
      <div className="flex flex-col w-full">
        <Header />
        <Outlet />
      </div>
    </div>
  );
};

export default Root;
